export enum MainHeaderTitle {
    PROFILE = 'profile',
    EVENTS = 'events',
    ARTISTS = 'artists',
    LOCATIONS = 'locations',
    CUSTOM_TAB = 'customTab',
}